interface FormattedPhoneNumber {
  value: string;
  caretPosition: number;
}

const toNationalDigits = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  const hasCountryCode = digits.length === 11 && digits.startsWith("1");

  return hasCountryCode ? digits.slice(1) : digits.slice(0, 10);
};

const groupDigits = (digits: string): string => {
  if (digits.length === 0) return "";
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const positionAfterDigits = (formatted: string, digitCount: number): number => {
  if (digitCount === 0) return 0;

  let seenDigits = 0;
  for (let index = 0; index < formatted.length; index += 1) {
    if (/\d/.test(formatted[index])) seenDigits += 1;
    if (seenDigits === digitCount) return index + 1;
  }
  return formatted.length;
};

export const formatPhoneNumber = (value: string): string => groupDigits(toNationalDigits(value));

export const formatPhoneNumberKeepingCaret = (
  value: string,
  caretPosition: number
): FormattedPhoneNumber => {
  const allDigits = value.replace(/\D/g, "");
  const nationalDigits = toNationalDigits(value);
  const droppedCountryCode = allDigits.length === 11 && allDigits.startsWith("1");
  const digitsBeforeCaret = value.slice(0, caretPosition).replace(/\D/g, "").length;
  const nationalDigitsBeforeCaret = Math.min(
    Math.max(digitsBeforeCaret - (droppedCountryCode ? 1 : 0), 0),
    nationalDigits.length
  );
  const formatted = groupDigits(nationalDigits);

  return {
    value: formatted,
    caretPosition: positionAfterDigits(formatted, nationalDigitsBeforeCaret),
  };
};
